module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADpSURBVDiNjZJrccNADIT3isAQDoIhBIIhXBk0CAqhEAwhEAyhYWAzcBl8+SO1quLzZGc8npO0q6eUAFTgE/gGdvsWsw05PpMvwEofO3DpkccUPAMT0IAvIzvGTB5C5hWondZ+Y7KzHambvXnvJuJoUWA24xJsSwheD+w3SXozu5d893lIisOqYXh3+w9R4Ce1nN+R6NiigDsnSSqlbJKuJrRJei+luKhX8pekO5wE4ONslT7IszX6LSzZnwP+iaQb2I8SeOAUV2fEms77+JSDSAuV7CnzdEoOImPKuj4N7QWRalc3d3uW9AAd07QGBHrW/wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/address.png
// module id = Li64
// module chunks = 1